export default __webpack_public_path__ + "static/media/moc_pomidora.8f68d66f.jpg";